import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewChildren} from '@angular/core';
import {Folder} from 'storyboard-renderer';
import {StoryboardService} from "../../shared/storyboard.service";
import {TemplateService} from "../../../template/shared/template.service";
import {AlertService} from "../../../shared/alert/alert.service";
import {Alert} from "../../../shared/alert/Alert";
import {TemplateFolderShareService} from "../../../template/shared/template-folder-share.service";
import {TemplateFolderSubscriptionService} from "../../../template/shared/template-folder-subscription.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ShareModalComponent} from "../../../shared/share-modal/share-modal.component";
import {PromptModalComponent} from "../../../shared/prompt-modal/prompt-modal.component";

@Component({
  selector: 'app-folder',
  templateUrl: './folder.component.html',
  styleUrls: ['./folder.component.scss']
})
export class FolderComponent implements OnInit {

  @Input() folder;
  @Input() type = 'storyboard';
  @Input() shareable = false;

  @Output() deleteFolderEvent = new EventEmitter();
  @Output() onUnsubscribed = new EventEmitter();

  @ViewChildren('editFolderInput') vc;

  tmpFolderTitle: string;
  service;

  constructor(private storyboardService: StoryboardService, private templateService: TemplateService, private alertService: AlertService,
              private templateFolderShareService: TemplateFolderShareService, private templateFolderSubscriptionService: TemplateFolderSubscriptionService,
              private modalService: NgbModal) { }

  ngOnInit() {
    this.service = this.type === 'storyboard' ? this.storyboardService : this.templateService;
  }

  deleteFolder() {
    if (this.folder.items.length) {
      this.alertService.danger(new Alert('This folder is not empty, please delete the content first'));
      return;
    }

    this.deleteFolderEvent.next(this.folder);
  }

  editMode(folder: Folder) {
    folder.editing = true;
    this.tmpFolderTitle = folder.title;

    this.vc.first.nativeElement.focus();
  }

  save(folder: Folder) {
    if (!this.tmpFolderTitle) {
      return;
    }

    folder.title = this.tmpFolderTitle;

    this.service.updateFolder(folder).then(() => {
      folder.editing = false;
    });
  }

  openShareModal(folder) {
    const shareModal = this.modalService.open(ShareModalComponent, {windowClass: 'share-modal'});
    shareModal.componentInstance.folder = folder;
  }

  unSubscribeFolder(event, folder) {
    event.stopPropagation();

    const modalRef = this.modalService.open(PromptModalComponent);
    modalRef.componentInstance.body = 'Are you sure you want to unsubscribe?';

    modalRef.result.then((result) => {
      folder.unsubscribing = true;
      this.templateFolderSubscriptionService.delete(folder).then(() => {
        folder.unsubscribing = false;
        this.onUnsubscribed.next(this.folder);
      }).catch((err) => {
        folder.unsubscribing = false;
      });
    }).catch((no) => {});

  }

}



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-list/folder/folder.component.ts